import dynostore, { dynamicReducers } from "@redux-dynostore/core";
import { combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { load, save } from "redux-localstorage-simple";
import { applyMiddleware } from "redux-subspace";
import thunk from "redux-thunk";
import adminRegisterReducer from "./modules/adminRegister";
import cookieConsent from "./modules/cookieConsent";
import { refreshSource, source } from "./modules/http";
import joinReducer from "./modules/join";
import layout from "./modules/layout";
import loginReducer from "./modules/login";
import profileManagement from "./modules/profileManagement";
import recoveryReducer from "./modules/recovery";
import registerReducer from "./modules/register";
import themeReducer from "./modules/theme";

export default function configureStore(preloadedState) {
  const appReducer = combineReducers({
    loginReducer,
    registerReducer,
    adminRegisterReducer,
    joinReducer,
    layout,
    recoveryReducer,
    themeReducer,
    cookieConsent,
    profileManagement,
  });

  const rootReducer = (state, action) => {
    return appReducer(
      action.type === "LOGOUT" ? resetReduxAxios() : state,
      action
    );
  };

  const resetReduxAxios = () => {
    source.cancel();

    refreshSource();
    return undefined;
  };

  const middlewares = applyMiddleware(
    thunk,
    save({ states: ["cookieConsent"] })
  );

  const getEnhancers = () => {
    return composeWithDevTools(middlewares, dynostore(dynamicReducers()));
  };

  const state = {
    ...preloadedState,
    ...(load({ states: ["cookieConsent"] }) || {}),
  };

  const store = createStore(rootReducer, state, getEnhancers());

  return { store };
}

export const sessionToken = "sessionToken";
export const sessionRole = "sessionRole";
export const sessionStudies = "sessionStudies";
export const sessionClaims = "sessionClaims";
export const sessionSites = "sessionSites";
export const sessionUsername = "sessionUsername";
export const sessionName = "sessionName";
export const sessionLanguage = "sessionLanguage";

export const nutritionixData = {
  apiBase: "https://trackapi.nutritionix.com",
  appId: "280c5220",
  appKey: "6dfe9ed64d903df540fb1832f0bc795e",
};

export const requestNutritionixConfig = () => {
  return {
    headers: {
      "x-app-id": nutritionixData.appId,
      "x-app-key": nutritionixData.appKey,
    },
  };
};

export const apiBase = () => {
  return apiBaseNew();
};

/**
 * To test locally remember to add an entry per study to your hosts file!
 * 127.0.0.1  STUDY.rarify.dev
 * EG: UX007-CL402.rarify.org
 */
const splitHostname = () => window.location.hostname.split(".");
export const currentStudy = () =>
  process?.env?.REACT_APP_STUDY || splitHostname()[0];
export const currentBranch = () => process?.env?.REACT_APP_BRANCH || "ci2";
export const currentHost = () =>
  process?.env?.REACT_APP_HOST ||
  String(splitHostname()[splitHostname().length - 2] + ".org");
export const currentPort = () =>
  process?.env?.REACT_APP_PORT && process?.env?.REACT_APP_PORT?.length >= 1
    ? `:${process?.env?.REACT_APP_PORT}`
    : "";
//This will replace old apiBase when all branches are running MT standard
export const apiBaseNew = () =>
  `https://${currentStudy()}.v1.api.${currentBranch()}.${currentHost()}${currentPort()}`;
